export default function Empty() {
  return (
    <div className="p-5 d-flex flex-column justify-content-center align-items-center">
      <p className="empty-title h4">No tweets here</p>
      <p className="text-muted">Post your first tweet above.</p>
    </div>
  );
}
